import React from 'react';
import { Route, Switch } from "react-router-dom";
import NotFound from '../../pages/NotFound';
import { routes } from "../../routes";
import AuthRoute from "../PrivateRoute/AuthRoute";

export default function RouterContainer() {
  let result = null;

  if (routes.length > 0) {
    result = routes.map(route => (
      route.isPrivate
        ? <AuthRoute
          exact={route.exact}
          path={route.path}
          component={route.main}
          key={route.name} />
        : <Route
          exact={route.exact}
          path={route.path}
          component={route.main}
          key={route.name}
        />
    ));
  }
  return <div style={{ minHeight: '405px' }}>
    <Switch>
      {result}
      <Route component={NotFound} />
    </Switch>
  </div>
}